import React from 'react';
import './styles.css';
import { PageLayout, WorkingMessage } from '@BUP/components';

const DataPage = () => {

  return (
    <PageLayout pageName="Data">
      <WorkingMessage />
    </PageLayout>
  )
}

export default DataPage;